import React, { useEffect, useMemo, useState } from "react";
import { Tabs } from "../tabs/index";
import { TabRecebimentoSalarios } from "./tab-recebimento-salarios";
import { TabCambioParaViagens } from "./tab-cambio-para-viagens";
import { TabIntercambio } from "./tab-intercambio";

import './index.scss';
import { OutrosProdutos } from "../para-sua-empresa/components/outros-produtos";
import { FacilitacaoOtimizacao } from "../para-sua-empresa/components/facilitacao-otimizacao";
import { Link, useLocation } from "react-router-dom";

export const ProdutosParaVoce = () => {

  const location = useLocation();

  const [tabId, setTabId] = useState(1)

	useEffect(() => {
		if (location.state != null && location.state.tab !== undefined){
      console.log(location.state.tab)
      setTabId(location.state.tab)   
    }
	}, [location]);

  const tabs = [
    {
      id: 1,
      label: "Recebimento de salários de empresas estrangeiras",
      content: <TabRecebimentoSalarios />,
    },
    {
      id: 2,
      label: "Câmbio para viagens",
      content: <TabCambioParaViagens />,
    },
    {
      id: 3,
      label: "Intercâmbio para o Exterior",
      content: <TabIntercambio />,
    },
    {
      id: 4,
      label: "Cartão Global com Cashback",
      content: "",
      info: "Em breve",
      enable: false,
    },
  ];

  return (
    <div>
      <div className='container-principal para-voce'>
        <div className="sombra-title">
          <h1> [ Conheça nossos produtos para você ] </h1>
        </div>
      </div>

      <div className='teste-para-voce'>
        <div>
        <div className='dados-empresa' style={{backgroundColor:"#F8F8F9"}}>
          <div>
              <div>
                  <h1>
                      Não é só uma operação de câmbio:
                  </h1>
                  <p>
                    Oferecemos o que os outros oferecem, mas com eficiência, agilidade e personalização. Possuímos uma plataforma conectada à múltiplos players, possibilitando que você consiga as melhores condições e taxas do mercado para enviar ou receber uma remessa.
                  </p>
              </div>
              <div className='buttons-style'>
                  <Link to={"/cadastro"}>Abra sua Conta</Link>
              </div>
          </div>
      </div>
        </div>

        <div className="div-content">
          <Tabs tabs={tabs} id={tabId} setId={setTabId}/>
        </div>

        <div>
          <OutrosProdutos />
        </div>
      </div>
    </div>
  );
};
